import DateFieldWithTimeZone from '../../../../components/DateFieldWithTimeZone';

export default function DateColumn() {
  return <DateFieldWithTimeZone source="createDate" />;
}
